import React, { memo, useMemo, useRef } from "react";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import { Grid, makeStyles } from "@material-ui/core";

import {
  DELAY_WAVE_CUT_OFF_TIMES,
  DELAY_DEPART_TIMES,
  CONFIRM,
} from "../../../constants/strings";
import Button from "../../../components/Button";
import palette from "../../../components/styles/palette";

const useStyles = makeStyles(({ typography }) => ({
  inputLabel: {
    fontWeight: "bold",
  },
  row: {
    minHeight: typography.pxToRem(65),
  },
  buttonContainer: {
    marginTop: typography.pxToRem(50),
    justifyContent: "flex-end",
  },
  blueButton: {
    backgroundColor: palette.btn.blueFill,
    border: palette.btn.blueBorder,
    "&:hover": {
      backgroundColor: palette.btn.blueFill,
    },
  },
}));

const DisasterRecoveryForm = ({
  values,
  handleConfirm,
  dirty,
  isValid,
  initialValues,
}) => {
  const style = useStyles();
  const waveCutOffRef = useRef();
  const departTimeRef = useRef();

  const isConfirmDisable = useMemo(() => {
    const { waveCutOff, departTime } = values;
    return !(
      dirty &&
      isValid &&
      ((waveCutOff && initialValues.waveCutOff !== waveCutOff) ||
        (departTime && initialValues.departTime !== departTime))
    );
  }, [dirty, isValid, values, initialValues]);

  return (
    <>
      <Grid container spacing={2} className={style.row}>
        <Grid item xs={8}>
          <label
            className={style.inputLabel}
            htmlFor="waveCutOff"
          >{`${DELAY_WAVE_CUT_OFF_TIMES}:`}</label>
        </Grid>
        <Grid item xs={4}>
          <Field
            id="waveCutOff"
            component={TextField}
            name="waveCutOff"
            type="text"
            variant="outlined"
            data-testid="wave-cut-off"
            value={values.waveCutOff}
            inputRef={waveCutOffRef}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} className={style.row}>
        <Grid item xs={8}>
          <label
            className={style.inputLabel}
            htmlFor="departTime"
          >{`${DELAY_DEPART_TIMES}:`}</label>
        </Grid>
        <Grid item xs={4}>
          <Field
            id="departTime"
            component={TextField}
            name="departTime"
            type="text"
            variant="outlined"
            data-testid="depart-time"
            value={values.departTime}
            inputRef={departTimeRef}
          />
        </Grid>
      </Grid>
      <Grid container className={style.buttonContainer}>
        <Button
          minWidthZero
          onClick={handleConfirm}
          className={style.blueButton}
          bgColorDisabled={palette.btn.blueFill}
          opacityDisabled={0.5}
          data-testid="confirm-button"
          disabled={isConfirmDisable}
        >
          {CONFIRM}
        </Button>
      </Grid>
    </>
  );
};

export default memo(DisasterRecoveryForm);
